import { TokenIcon } from "@/components/brand/TokenIcon";
import { formatNum, cn } from "@/lib/utils";

export type CollateralLine = {
	asset: string;
	amount: number;
	priceUsd: number;
	valueUsd: number;
};

/** Single icon + amount + ticker + oracle price — no duplicates. */
export function CollateralLines({
	lines,
	className,
	compact,
}: {
	lines: CollateralLine[];
	className?: string;
	compact?: boolean;
}) {
	if (!lines.length) {
		return <p className="text-sm text-muted-foreground">No collateral</p>;
	}
	return (
		<ul className={cn("space-y-1.5", className)}>
			{lines.map((l) => (
				<li
					key={l.asset}
					className={cn(
						"flex flex-wrap items-center gap-x-2 gap-y-0.5",
						compact ? "text-xs" : "text-sm",
					)}
				>
					<span className="inline-flex min-w-0 flex-1 items-center gap-2">
						<TokenIcon token={l.asset} size="sm" plain />
						<span className="font-mono-amount font-semibold tabular-nums">
							{formatNum(
								l.amount,
								l.asset === "ckBTC" ? 6 : l.asset === "ckETH" ? 4 : 4,
							)}
						</span>
						<span className="font-semibold text-foreground">{l.asset}</span>
					</span>
					<span className="font-mono text-[11px] text-muted-foreground">
						@ ${formatNum(l.priceUsd, l.asset === "ICP" ? 2 : 0)}
					</span>
					<span className="ml-auto font-mono-amount font-semibold tabular-nums">
						${formatNum(l.valueUsd, 2)}
					</span>
				</li>
			))}
		</ul>
	);
}
